
import React from "react";
import { useTranslation } from "react-i18next";
import { Navbar } from "./Navbar";
import { motion } from "framer-motion";
import { Link as RouterLink } from "react-router-dom";

interface LayoutProps {
  children: React.ReactNode;
  className?: string;
}

export const Layout: React.FC<LayoutProps> = ({ children, className = "" }) => {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();
  
  return (
    <div className="min-h-screen flex flex-col bg-background">
      <Navbar />
      <motion.main
        initial={{ opacity: 0, y: 5 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.3 }}
        className={`flex-grow ${className}`}
      >
        {children}
      </motion.main>
      <footer className="py-8 px-6 md:px-10 border-t border-border">
        <div className="container max-w-7xl mx-auto">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <div className="flex items-center">
              <span className="font-display font-medium text-xl text-foreground/90">Fatato</span>
              <span className="text-primary ml-1 text-sm">Studio</span>
            </div>
            <div className="flex flex-col md:flex-row gap-6 items-center text-sm text-muted-foreground">
              <a href="https://fatato.am/" target="_blank" rel="noopener noreferrer" className="hover:text-foreground transition-colors">{t('footer.about')}</a>
              <RouterLink to="/classes" className="hover:text-foreground transition-colors">{t('footer.classes')}</RouterLink>
              <a href="https://fatato.am/" target="_blank" rel="noopener noreferrer" className="hover:text-foreground transition-colors">{t('footer.contact')}</a>
              <RouterLink to="/privacy" className="hover:text-foreground transition-colors">{t('footer.privacy')}</RouterLink>
            </div>
            <div className="text-sm text-muted-foreground mt-4 md:mt-0">
              {t('footer.copyright', { year: currentYear })}
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};
